import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  requestSubmit() {
    this.element.requestSubmit()
  }
}